"use client";

import Image from "next/image";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

const funFestImages = [
  {
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/placement-fun-fest-2.jpg",
  },
  {
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/placement-fun-fest-guidance.png",
  },
  {
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/placement-fun-fest-3.jpg",
  },
  {
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/placement-fun-fest-6.jpg",
  },
  {
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/placement-fun-fest-4.jpg",
  },
  {
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/placement-fun-fest-5.jpg",
  },
];

export default function FunFest() {
  return (
    <section className="page-container mx-auto pb-10 md:pb-12">
      {/* Title Section */}
      <div className="w-full text-left mb-2 md:mb-4">
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-2"
          style={{ fontFamily: "saans-bold" }}
        >
          Placement Fun Fest
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-black leading-relaxed w-full md:w-[80%] lg:w-[70%]">
          We organise interactive placement experiences where students practice
          group discussions, mock interviews, build confidence, sharpen
          communication skills and prepare effectively for real recruitment
          scenarios.
        </p>
      </div>

      {/* Mobile Swiper (< 768px) */}
      <div className="block md:hidden">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={16}
          loop={true}
          slidesPerView={1.2}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            prevEl: "#funFestPrevButton",
            nextEl: "#funFestNextButton",
          }}
          breakpoints={{
            640: { slidesPerView: 1.5 },
          }}
          className="funfest-swiper w-full"
        >
          {funFestImages.map((item, index) => (
            <SwiperSlide key={index} className="flex flex-col items-center">
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-gray-100">
                <Image
                  src={item.image}
                  alt="Placement Fun Fest"
                  fill
                  sizes="(max-width: 768px) 85vw"
                  className="object-cover object-top transition-transform duration-500 hover:scale-105"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Mobile Navigation Buttons */}
        <div className="flex justify-center gap-3 mt-6">
          <button
            id="funFestPrevButton"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
            aria-label="Previous"
          >
            <ChevronLeft className="w-5 h-5 text-gray-700" />
          </button>
          <button
            id="funFestNextButton"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
            aria-label="Next"
          >
            <ChevronRight className="w-5 h-5 text-gray-700" />
          </button>
        </div>
      </div>

      {/* Desktop Grid (>= 768px) */}
      <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {funFestImages.map((item, index) => (
          <div
            key={index}
            className="relative group overflow-hidden bg-gray-100 aspect-[4/3]"
          >
            <Image
              src={item.image}
              alt="Placement Fun Fest"
              fill
              sizes="(max-width: 1024px) 50vw, 33vw"
              className="object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
